/* cardstock 2020 */
$(document).ready(function() {

// Footer Navigation
$('.footer--column').on('click', function(event) {
  $(this).toggleClass('is--active');
});
// Footer Navigation

// Product Navigation
var openSidebar = function(){
$('#nav_pop_2, #nav_button_2').removeClass('is--active');
$('#nav_button').toggleClass('is--active');
$('#nav_pop').toggleClass('is--active');
}
var closeSidebar = function(){
$('#nav_button').removeClass('is--active');
$('#nav_pop').removeClass('is--active');
}

$('#nav_button').click( function(event) {
event.stopPropagation();
openSidebar();
$('.nav_pop-img img').attr('src', '/test/img/base/default.jpg');
});

$(document).click( function(event){
if ( !$(event.target).closest('#nav_pop').length ) {
    closeSidebar();
}
});


// change img on link hover
$('#nav_pop li a').hover(
    function(){
        var linkIndex = $(this).attr("data-image");
        $('.nav_pop-img img').attr('src', linkIndex+'.jpg');
    },
);

// preloade images
var images = [];
function preload() {
  for (var i = 0; i < arguments.length; i++) {
      images[i] = new Image();
      images[i].src = preload.arguments[i];
  }
}

  


// Contact Navigation
var openSidebar2 = function(){
$('#nav_pop, #nav_button').removeClass('is--active');
$('#nav_button_2').toggleClass('is--active');
$('#nav_pop_2').toggleClass('is--active');
}
var closeSidebar2 = function(){
$('#nav_button_2').removeClass('is--active');
$('#nav_pop_2').removeClass('is--active');
}

$('#nav_button_2').click( function(event) {
event.stopPropagation();
openSidebar2();
});

$(document).click( function(event){
if ( !$(event.target).closest('#nav_pop_2').length ) {
    closeSidebar2();
}
});
// Contact Navigation


// Resp Navigation

var openRsnav = function(){
$('body').addClass('rsnav-open');
}
var closeRsnav = function(){
$('body').removeClass('rsnav-open');
}

$('#open_rsnav').click( function(event) {
event.stopPropagation();
openRsnav();
});

$('#close_rsnav').click( function(event) {
event.stopPropagation();
closeRsnav();
});

$(document).click( function(event){
if ( !$(event.target).closest('#rsnav').length ) {
    closeRsnav();
}
});

// menu
$(function(){
  $(".rsnav_accordion").click(function(){
    $(this).toggleClass("open");
    if($(this).hasClass("open"))
      $(".rsnav_accordion").not(this).removeClass("open");
  })
})
// Resp Navigation


// smooth scroll
$(document).on('click', 'a[href^="#"]', function(e) {
    // target element id
    var id = $(this).attr('href');

    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // top position relative to the document
    var pos = $id.offset().top;

    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
});
// smooth scroll



//////////////////////////////////////////////////// contact

$('.tab-link').click(function() {
  var tab_id = $(this).attr('data-tab');
  var tab_id_input = $(this).children("input");

  $('ul.ctabs li').removeClass('current');
  $('ul.ctabs li input').prop('checked', false).removeAttr('checked');
  $('.contact--group').removeClass('current');

  $("." + tab_id).addClass('current');
  $(tab_id_input).prop('checked', true).attr('checked', 'checked');
  $("#" + tab_id).addClass('current');
})

//////////////////////////////////////////////////// contact



var controller = new ScrollMagic.Controller();

// animate content in
$('.animate1').each(function() {
  var moveup = this;
  var scene = new ScrollMagic.Scene({
      triggerElement: moveup,
      reverse: false
    })
    .setTween(moveup, 0.7, {
      y: 0,
      opacity: 1,
      delay: 1,
      ease: Power2.easeInOut
    })
    .addTo(controller);
  var triggerHook = scene.triggerHook();
  scene.triggerHook(1);
});

// animate content in
$('.animate2').each(function() {
  var moveup = this;
  var scene = new ScrollMagic.Scene({
      triggerElement: moveup,
      reverse: false
    })
    .setTween(moveup, 0.7, {
      y: 0,
      ease: Power2.easeInOut
    })
    .addTo(controller);
  var triggerHook = scene.triggerHook();
  scene.triggerHook(1);
});

  var controller = new ScrollMagic.Controller();

// animate Text in
$('.textanimate').each(function() {
  var moveup = this;
  var scene = new ScrollMagic.Scene({
      triggerElement: moveup,
      reverse: false
    })
    .setTween(moveup, 0.7, {
      backgroundSize: "+=100% +=0px",
      ease: Power2.easeInOut
    })
    .addTo(controller);
});

  


});
